import React from "react";
import CircleImage from "../../../../components/Image/CircleImage";

export default function CollaboratorCard({ collaborator, handleSetEditCollaborator, handleDeleteCollaborator }) {
  return (
    <div className="col-12 col-lg-4 mb-4 ">
      <div className="d-flex align-items-center p-3 cell-onhover c-pointer collaborator-item">
        <div
          className="d-flex align-items-center col-10 me-auto"
          onClick={() => handleSetEditCollaborator(collaborator)}
        >
          <CircleImage url={collaborator?.avatar} sizePx="60px" />

          <div>{collaborator.name}</div>
        </div>
        <div className="btn-group">
          <button type="button" className="btn dropdown-toggle p-0" data-bs-toggle="dropdown" aria-expanded="false">
            <i className="bi bi-three-dots-vertical"></i>
          </button>
          <ul className="dropdown-menu" style={{ borderRadius: "10px" }}>
            <li>
              <span
                className="dropdown-item fz-14 ff-univanova-regular c-pointer text-cl-black"
                data-bs-toggle="modal"
                data-bs-target="#myModalSingle"
                onClick={() => handleSetEditCollaborator(collaborator)}
              >
                Editar
              </span>
            </li>
            <li>
              <span
                className="dropdown-item fz-14 ff-univanova-regular text-prop-danger c-pointer text-cl-red"
                onClick={() => handleDeleteCollaborator(collaborator._id)}
              >
                Excluir
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
